<template>
  <form @submit.prevent="submit" class="login mx-auto col-md-4">
      <h5>Inloggen</h5>
    <div class="form-group">
    <label for="exampleInputEmail1">Email address</label>
    <input type="email" class="form-control" v-model="email" autocomplete="email" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
  </div>
  <div class="form-group">
    <label for="exampleInputPassword1">Password</label>
    <input type="password" class="form-control" v-model="password" id="exampleInputPassword1" placeholder="Password">
  </div>
  <button type="submit" class="btn btn-outline-primary" @click="submit">Inloggen</button>
  </form>
</template>

<script>
import { mapMutations } from "vuex";
export default {
    data(){
        return {
            email: undefined,
            password: undefined
        }
    },
    methods:{
        submit(){
            this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(user=>{
                this.$alertify.success("Logged in successfully!")
                this.$router.replace("home")
            })
        }
    }
};
</script>
